// extracted by mini-css-extract-plugin
export default {"cover_section":"home-cover_cover_section__i-tNo","logoCover":"home-cover_logoCover__vJuhc","logo":"home-cover_logo__YjiNl","coverImg":"home-cover_coverImg__fHdRm"};